import { createContext, useContext, useState } from 'react';

const PoseCaptureContext = createContext({
  capturePoseFn: null,
  setCapturePoseFn: () => {}
});

export const PoseCaptureProvider = ({ children }) => {
  const [capturePoseFn, setCapturePoseFn] = useState(null);

  return <PoseCaptureContext.Provider value={{ capturePoseFn, setCapturePoseFn }}>{children}</PoseCaptureContext.Provider>;
};

export const usePoseCapture = () => useContext(PoseCaptureContext);
